import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 上下游商品
 * @author xieyang
 */
import api from 'api/goodsDetail';
import { mapGetters } from 'vuex';
import { GET_SCREEN, GET_GOODS_TEMPLATE } from '$getters';
export default {
  name: 'module-up-downstream',
  data: function data() {
    return {
      selectTemplate: 'up',
      goodsId: null,
      list: [],
      pageConfig: {
        page: 0,
        size: 10
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    screen: GET_SCREEN,
    goodsTemplateArray: GET_GOODS_TEMPLATE
  })), {}, {
    fetchFun: function fetchFun() {
      var vm = this;

      switch (vm.selectTemplate) {
        case 'up':
          return api.selectUpstreamGoods;

        case 'down':
          return api.selectDownstreamGoods;

        case 'brother':
          return api.selectGoodsBrother;
      }

      return null;
    },
    goodsTemplate: function goodsTemplate() {
      if (this.goodsTemplateArray) {
        var length = this.goodsTemplateArray.length + 1;
        var templates = new Array(length);
        this.goodsTemplateArray.forEach(function (item) {
          templates[item.templateId] = item.templateIdName;
        });
        return templates;
      }

      return [];
    }
  }),
  watch: {
    '$route.query': {
      handler: function handler(val) {
        if (val && val['goodsId']) {
          this.$set(this.pageConfig, 'goodsId', val.goodsId);
          this.goodsId = val['goodsId'];
        }
      },
      immediate: true
    },
    selectTemplate: function selectTemplate(val) {
      this.$refs.list.flushList();
    }
  },
  methods: {
    toDetail: function toDetail(id) {
      this.$router.push({
        path: '/goodsDetail',
        query: {
          goodsId: id
        }
      });
    }
  }
};